import React from "react";
import QRCode from "react-qr-code";
import * as R from "ramda";

import { Row, Col } from 'antd';

import logo from '../assets/images/image_logo_new.png';
import closeImg from '../assets/images/icon-icon-cancel-30@3x.png';
import likeImg from '../assets/images/icon-post-interact-unlike-24@3x.png';
import commentImg from '../assets/images/icon-post-interact-comment-24@3x.png';


export default function PopUp(props) {
    const {pid, gid, email, popUpState, setPopUpState} = props;

    const openAppUrl = `https://fitgames.tw/applink?type=6&pid=${pid}`;
    const openAppUrlHome = `https://fitgames.tw/applink?type=1`;
    const openAppUrlGame = `https://fitgames.tw/applink?type=9&gid=${gid}`;
    const openAppUrlWall = `https://fitgames.tw/applink?type=13&email=${email}`;

    const linkToHome = popUpState.popUpType !== "like" && popUpState.popUpType !== "comment" && popUpState.popUpType !== "game" && popUpState.popUpType !== "wall";

    const handleClose = () => {
        setPopUpState(!popUpState.isOpen);
    }

    const handleOpenApp = () => {
        window.open(
            linkToHome ? openAppUrlHome
                : popUpState.popUpType === "wall" ? openAppUrlWall
                    : openAppUrl
            , "_self");
    }

    const openUrl = {
        get appUrl () {
            switch (popUpState.popUpType) {
                case "game":
                    return openAppUrlGame
                case "wall":
                    return openAppUrlWall
                default:
                    return linkToHome ? openAppUrlHome : openAppUrl
            }
        }
    }

    return (
        <div >
            <div className={R.or(popUpState.popUpType === "game", popUpState.popUpType === "normalGame") ? "popup-outerbox-game" : "popup-outerbox"}>
                <div className="popup-box">
                    <div className="popup-close-btn-box">
                        <button className="popup-close-btn" onClick={() => handleClose()}>
                            <img src={closeImg} className="web-img" alt="close" />
                        </button>
                    </div>

                    <Row type="flex" justify="center" align="top" style={{ textAlign: "center" }}>
                        <Col span={24}>
                            <img src={logo} className="popup-logo" alt="logo" />
                        </Col>
                        <Col span={24} align="center">
                            <PopUpIcon popUpType={popUpState.popUpType} />
                            <PopUpContent popUpType={popUpState.popUpType} />

                            <div>
                                <button className="popup-app-btn" onClick={() => handleOpenApp()}>
                                    <font className="popup-app-btn-text">開啟應用程式</font>
                                </button>
                            </div>
                            <div>
                                <button className="popup-later-btn" onClick={() => handleClose()}>
                                    <font className="popup-later-btn-text">稍後再說</font>
                                </button>
                            </div>
                        </Col>

                        <Col span={24}>
                            <div className="popup-qrcode">
                                <QRCode
                                    value={openUrl.appUrl}
                                    size={166} />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}


const PopUpContent = (props) => {
    const popUpType = props.popUpType;

    if (popUpType === "like") {
        return (
            <div className="popup-text-box">
                <div className="popup-text-main-box">
                    <font className="popup-text-main">成為FitGames會員即可按讚</font>
                </div>
                <font className="popup-text-sub">並獲得完整的使用體驗</font>
            </div>
        );
    } else if (popUpType === "comment") {
        return (
            <div className="popup-text-box">
                <div className="popup-text-main-box">
                    <font className="popup-text-main">成為FitGames會員即可留言</font>
                </div>
                <font className="popup-text-sub">並獲得完整的使用體驗</font>
            </div>
        );
    } else if (popUpType === "game") {
        return (
            <div className="popup-text-box">
                <div className="popup-text-main-box">
                    <font className="popup-text-main">成為FitGames會員即可報名競賽</font>
                </div>
                <font className="popup-text-sub">並獲得完整的使用體驗</font>
            </div>
        );
    } else {
        return (
            <div className="popup-text-box">
                <font className="popup-text-sub">掃描QRCode、下載APP並成為會員，享有最新體態競賽相關資訊、紀錄並上傳運動數據，獲得完整的使用體驗。</font>
            </div>
        );
    }
}

const PopUpIcon = (props) => {
    const popUpType = props.popUpType;


    if (popUpType === "like") {
        return (
            <div className="popup-icon-padding">
                <img src={likeImg} className="popup-icon" alt="like" />
            </div>

        );
    } else {
        return (
            <div className="popup-icon-padding">
                <img src={commentImg} className="popup-icon" alt="comment" />
            </div>
        );
    }

}
